module.exports = __webpack_public_path__ + "static/media/qrcode-download-dark.32b8a3ec.svg";